import React, { PropTypes } from "react";
import logo from "../../assets/images/logo.svg";
import CreatePasswordForm from "./ResetPasswordForm";

const ResetPasswordPage = (props) => {
  const {
    location: {
      query: { token },
      state,
    },
  } = props;
  const [firstName, isPasswordExpired] = state ? [state.firstName, state.isPasswordExpired] : [null, null];
  return (
    <div className="login-page">
      <div className="login-form reset-form">
        <h1>
          <img src={logo} width="200" height="50" alt="Major" />
        </h1>

        <CreatePasswordForm
          token={token}
          firstName={firstName}
          isPasswordExpired={isPasswordExpired}
        />
      </div>
    </div>
  );
};

ResetPasswordPage.propTypes = {
  location: PropTypes.object,
};

export default ResetPasswordPage;



// WEBPACK FOOTER //
// ./src/components/reset-password/ResetPasswordPage.js